import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import '@coreui/coreui/dist/css/coreui.min.css';
import './index.css';
import { App } from './App.js';

const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000;

registerSW({
    immediate: true,
    onRegisteredSW(_swUrl, registration) {
        if (registration == null) {
            return;
        }
        // iOS reopens a home-screen PWA from a suspended state rather than a
        // fresh navigation, so the browser doesn't get a chance to notice a
        // new sw.js on its own — poll explicitly whenever the app resumes.
        setInterval(() => void registration.update(), UPDATE_CHECK_INTERVAL_MS);
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                void registration.update();
            }
        });
    },
});

const rootElement = document.getElementById('root');
if (rootElement == null) {
    throw new Error('Root element #root not found');
}

ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
